import { IAidasCustomer } from 'app/shared/model/ainnotateservice/aidas-customer.model';

export interface IAidasProject {
  id?: number;
  name?: string;
  description?: string | null;
  projectType?: string | null;
  aidasCustomer?: IAidasCustomer;
}

export const defaultValue: Readonly<IAidasProject> = {};
